import { IBoundingBox } from './IBoundingBox.js';
import { IBoundingSphere } from './IBoundingSphere.js';
import { IMatrix4 } from './IMatrix4.js';
import { IVector3 } from './IVector3.js';
import { IVector4 } from './IVector4.js';
export class ITransformedBoundingBox {
    constructor(local_bounding_box, transform) {
        return {
            local_bounding_box: local_bounding_box,
            transform: transform
        };
    }
    static get_center(bounds) {
        return IVector3.add_in_place(IBoundingBox.get_center(bounds.local_bounding_box), bounds.transform[3]);
    }
    static get_transformed_vertices(bounds) {
        const result = IBoundingBox.get_vertices(bounds.local_bounding_box);
        const vertex = new IVector3();
        for (let i = 0; i < 8; i++) {
            IVector3.copy_to_ref(result[i], vertex);
            IMatrix4.transform_vector3_to_ref(bounds.transform, vertex, result[i]);
        }
        return result;
    }
    static get_encapsulating_axis_aligned_bounding_box(bounds) {
        const min = new IVector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        const max = new IVector3(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
        const vertices = ITransformedBoundingBox.get_transformed_vertices(bounds);
        for (let i = 0; i < 8; i++) {
            IVector3.min_to_ref(min, vertices[i], min);
            IVector3.max_to_ref(max, vertices[i], max);
        }
        return new IBoundingBox(min, max);
    }
    static to_bounding_sphere(bounding_box) {
        const center = ITransformedBoundingBox.get_center(bounding_box);
        let radius = -Number.MAX_VALUE;
        const vertices = ITransformedBoundingBox.get_transformed_vertices(bounding_box);
        for (let i = 0; i < 8; i++) {
            radius = Math.max(IVector3.distance_squared(center, vertices[i]), radius);
        }
        radius = Math.sqrt(radius);
        return new IBoundingSphere(center, radius);
    }
    static get_face_plane(bounds, direction) {
        const local_plane = IBoundingBox.get_face_plane(bounds.local_bounding_box, direction);
        const transformed_plane = {
            normal: IMatrix4.transform_vector4(bounds.transform, new IVector4(local_plane.normal.x, local_plane.normal.y, local_plane.normal.z, 0.0)),
            position: IMatrix4.transform_vector3(bounds.transform, local_plane.position)
        };
        return transformed_plane;
    }
}
//# sourceMappingURL=ITransformedBoundingBox.js.map